exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n#scene-container[data-v-c46cf046] {\n  width: 900px;\n  height: 70vh;\n  max-width: 100%;\n  max-height: 100%;\n  background: linear-gradient(180deg, #e6e6e6 0%, #f6f6f6 46%, #ffffff 50%, #f6f6f6 54%, #e6e6e6 100%);\n}", ""]);

// exports
